import { styled as e } from "styled-components";
//#region src/components/CodeBlock/CodeBlock.styled.ts
var t = e.div`
    display: flex;
    flex-direction: column;
    min-width: 0;
    border: 1px solid ${({ theme: e }) => e.colors.border};
    border-radius: ${({ theme: e }) => e.radii.lg};
    background: ${({ theme: e }) => e.colors.muted};
    overflow: hidden;
`, n = e.div`
    display: flex;
    align-items: center;
    gap: ${({ theme: e }) => e.spacing(1)};
    min-height: 40px;
    padding: ${({ theme: e }) => `${e.spacing(.5)} ${e.spacing(.5)} ${e.spacing(.5)} ${e.spacing(1.5)}`};
    border-bottom: 1px solid ${({ theme: e }) => e.colors.border};
`, r = e.div`
    flex: 1;
    min-width: 0;
`, i = e.pre`
    margin: 0;
    padding: ${({ theme: e }) => e.spacing(1.5)};
    font-family: ui-monospace, SFMono-Regular, Menlo, monospace;
    font-size: ${({ theme: e }) => e.typographyTokens.sizes.xs};
    line-height: 1.6;
    color: ${({ theme: e }) => e.colors.foreground};
    white-space: ${({ $wrap: e }) => e ? "pre-wrap" : "pre"};
    overflow-wrap: ${({ $wrap: e }) => e ? "anywhere" : "normal"};
    overflow: auto;
    max-height: ${({ $maxHeight: e }) => e === void 0 ? "none" : `${e}px`};
`, a = e.div`
    display: flex;
    justify-content: center;
    padding: ${({ theme: e }) => e.spacing(.5)};
    border-top: 1px solid ${({ theme: e }) => e.colors.border};
`;
//#endregion
export { a as Footer, t as Frame, n as Header, r as HeaderLabel, i as Pre };
